import interceptorHttp from '@/application/listeners/InterceptadorHttp'
import registerGlobalComponentsListener from '@/application/listeners/RegisterGlobalComponentsListener'
import registerGlobalFiltersListener from '@/application/listeners/RegisterGlobalFiltersListener'
import buscarParametrosDoSistemaListener from '@/application/listeners/BuscarParametrosDoSistemaListener'
import buscarProdutoListener from '@/application/listeners/BuscarProdutoListener'
import setFusoHorarioListener from '@/application/listeners/SetFusoHorarioListener'
import setConfigLoki from '@/application/listeners/SetConfigLoki'

export default {
	interceptorHttp,
	registerGlobalComponentsListener,
	registerGlobalFiltersListener,
	buscarParametrosDoSistemaListener,
	buscarProdutoListener,
	setFusoHorarioListener,
	setConfigLoki,
}
